import { gql } from "@apollo/client";

//Update this!
export const AVAILABLE_OFFICERS_QUERY = gql`
  query AVAILABLE_OFFICERS_QUERY(
    $oriIds: String!
    $homeOriId: ID!
    $originatorId: ID!
    $noSessionReset: Boolean
  ) {
    availableOfficers(
      oriIds: $oriIds
      homeOriId: $homeOriId
      originatorId: $originatorId
      noSessionReset: $noSessionReset
    ) {
      id
      deptAttribute {
        id
        badge
        assignment
        carNumber
        loanerOriAbbreviations
        radioNumber
        stateIdNumber
        ori {
          id
          oriName
          abbreviation
          municipalityNumber
        }
        team {
          id
          name
        }
        secondaryAddress
        officerLocation
        notes
        skillsList
        lastContactedAt
        status
        onDuty
      }
      personalAttribute {
        id
        firstName
        lastName
      }
    }
  }
`;
